import React, { useState } from 'react';
import classnames from 'classnames';
import Modal from 'react-modal';

import { LeadForm } from '../../LeadForm/LeadForm';
import { GTM_ACTION } from '../../../lib/constant';

import styles from './LeadFormModal.module.scss';
import useResponsive from '../../../utils/hooks/useResponsive';

export interface LeadFormModalProps {
  popupData?: any;
  closePopup: Function;
}

export const LeadFormModal = (props: LeadFormModalProps) => {  
  const { isDesktop } = useResponsive();
  const { popupData, closePopup } = props;
  const [isOpen, setIsOpen] = useState(true);

  const close = () => {
    setIsOpen(false);
    closePopup();
  };

  const showFeatures = () => {
    return (
      <>
        {popupData.featureFirst && (
          <div
            className={styles.leadFormModal__label}
            dangerouslySetInnerHTML={{ __html: popupData.featureFirst }}
          />
        )}
        {popupData.rating && popupData.totalReviewer && (
          <div className={styles.leadFormModal__label}>
            <span className="text-bold">{`${popupData.rating} / 5.0`}</span>
            {` - ${popupData.totalReviewer} Google Review`}
          </div>
        )}
        {popupData.featureSecond && (
          <div
            className={styles.leadFormModal__label}
            dangerouslySetInnerHTML={{ __html: popupData.featureSecond }}
          />
        )}
      </>
    );
  };

  return (
    <Modal
      className={styles.leadFormModal__dialog}
      isOpen={isOpen}
      wrapClassName={styles.leadFormModal__wrapper}
      modalClassName={styles.leadFormModal__modal}
      contentClassName={styles.leadFormModal__content}
      backdropClassName={styles.leadFormModal__backdrop}
      onExit={close}
      overlayClassName={styles.leadFormModal__overlay}
    >
      {popupData && popupData.bannerMobileUrl && popupData.bannerDesktopUrl && (
        <div
          className={classnames(
            styles.leadFormModal__banner,
            isDesktop
              ? styles['leadFormModal__banner--desktop']
              : styles['leadFormModal__banner--mobile'],
          )}
        >
          <img
            width="322px" height="280px"
            src={isDesktop ? popupData.bannerDesktopUrl : popupData.bannerMobileUrl}
            loading="lazy"
            className={styles['leadFormModal__banner-image']}
            alt="Lead form banner"
          />
        </div>
      )}

      <div className={styles.leadFormModal__header}>
        {popupData && popupData.title && (
          <h3 dangerouslySetInnerHTML={{ __html: popupData.title }} />
        )}
        <button
          type="button"
          className={styles['leadFormModal__button-close']}
          onClick={close}
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div className={styles.leadFormModal__body}>
        {showFeatures()}
        <LeadForm
          background="light"
          gtmAction={popupData.gtmAction || GTM_ACTION.LEAD_SUBMIT}
          category={popupData.category}
          category_value={popupData.category_value}
        />
      </div>
    </Modal>
  );
};

export default LeadFormModal;
